<div *ngIf="loaderState !== undefined && loaderState.isVisible" class="loader"><mat-spinner color="warn" strokeWidth="3" diameter="60"></mat-spinner></div>
